import React, { useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import {
  arrayOf,
  bool,
  func,
  number,
  object,
  oneOfType,
  shape,
  string,
} from 'prop-types';
import { arrToStr, splitStringToArrayByComma } from 'services/utils';
import { UNLIMITED_VALUE, ONE_BYTE_COMMA_SEPERATOR } from 'domain/consts';
import EbisDropdown from 'views/atoms/dropdown/EbisDropdown';
import ErrorTooltipWrapper from 'views/atoms/tooltip/ErrorTooltipWrapper';

function FilterTypeTwo(props) {
  const {
    keepOption,
    options,
    onChange,
    onDelete,
    presets,
    note,
    error,
    clearError,
  } = props;
  const ref = useRef();
  // Since API return values in arr example ['item1', 'item2']
  const initialValues = presets.values
    ? [
        arrToStr(
          presets.values,
          false,
          UNLIMITED_VALUE,
          ONE_BYTE_COMMA_SEPERATOR
        ),
      ]
    : [''];
  const [values, setValues] = useState(initialValues);
  const initialOption = presets.option ? presets.option : options[0].key;
  const [option, setOption] = useState(initialOption);
  const [objOptionSelected, setObjOptionSelected] = useState(
    options.find((optionItem) => optionItem.key === option)
  );

  const errorMess = (error && Object.values(error)[0]) || '';
  const isShowOption = options.length > 1 || keepOption;

  const onTextChange = (e) => {
    const splittedValues = splitStringToArrayByComma(e.target.value, false);
    setValues([e.target.value]);
    onChange(splittedValues, option);
  };

  const onOptionChange = (value) => {
    const splittedValues = splitStringToArrayByComma(values[0], false);
    const valueOption = parseInt(value, 10);
    const objOption = options.find(
      (optionItem) => optionItem.key === valueOption
    );
    setObjOptionSelected(objOption);
    setOption(valueOption);
    onChange(splittedValues, valueOption);
  };

  return (
    <div className="filter-type__two">
      {isShowOption && (
        <EbisDropdown
          optionObject={options}
          selectCallback={onOptionChange}
          defaultVal={option}
          isDisabled={options.length <= 1}
        >
          {onDelete && (
            <div
              className="filter-type__icon-delete icon-hover"
              role="button"
              aria-hidden="true"
              onClick={onDelete}
            >
              <i className="fal fa-times" />
            </div>
          )}
        </EbisDropdown>
      )}
      <Form.Group>
        <div ref={ref} className="form-input-keep-position">
          <ErrorTooltipWrapper
            isError={errorMess.length > 0}
            errorMess={errorMess}
            ref={ref}
            isNeedScrollIntoView={false}
          >
            <Form.Control
              type="text"
              size="sm"
              placeholder={objOptionSelected?.disabledInput ? '' : '値を入力'}
              onChange={onTextChange}
              value={values}
              className={error ? 'error' : ''}
              disabled={!!objOptionSelected?.disabledInput}
            />
          </ErrorTooltipWrapper>
        </div>
        {!isShowOption && <Form.Label>{options[0].label}</Form.Label>}
      </Form.Group>
      {note && <div className="filter-type__note">{note}</div>}
    </div>
  );
}

FilterTypeTwo.propTypes = {
  // name: string.isRequired,
  options: arrayOf(shape({ key: number, value: string })).isRequired,
  onChange: func,
  presets: shape({ values: arrayOf(string) }),
  // eslint-disable-next-line react/forbid-prop-types
  error: object,
  clearError: func,
  note: string,
  onDelete: oneOfType([bool, func]),
  keepOption: bool,
};

FilterTypeTwo.defaultProps = {
  onChange: () => {},
  presets: {},
  error: null,
  clearError: () => {},
  note: '',
  onDelete: false,
  keepOption: false,
};

export default FilterTypeTwo;
